import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { convertToCents } from '../../../../../../helpers/money';

export const useSalaryFilter = ({ setFilters }) => {
  const currencyOptions = [
    { label: 'AUD', value: 'AUD' },
    { label: 'BRL', value: 'BRL' },
    { label: 'CAD', value: 'CAD' },
    { label: 'EUR', value: 'EUR' },
    { label: 'GBP', value: 'GBP' },
    { label: 'INR', value: 'INR' },
    { label: 'JPY', value: 'JPY' },
    { label: 'MXN', value: 'MXN' },
    { label: 'NZD', value: 'NZD' },
    { label: 'SGD', value: 'SGD' },
    { label: 'USD', value: 'USD' },
  ];

  const periodOptions = [
    { label: 'Per year', value: 'year' },
    { label: 'Per month', value: 'month' },
    { label: 'Per day', value: 'day' },
    { label: 'Per hour', value: 'hour' },
  ];

  const formSchema = Yup.object().shape({
    amountMin: Yup.string().nullable(),
    currency: Yup.object().nullable(),
    period: Yup.object().nullable(),
  });

  const onSubmit = ({ amountMin, currency, period }) => {
    const salary = {
      compensationAmountMinCents: amountMin ? convertToCents(amountMin) : null,
      currency: currency?.value || null,
      period: period?.value || null,
    };

    setFilters({ salary });
  };

  return {
    formSchema,
    onSubmit,
    currencyOptions,
    periodOptions,
  };
};

useSalaryFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
};
